import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axiosProtected from "../config/baseWithToken";

export const getNotifications = createAsyncThunk(
  "store/notifications/get",
  async (notification, thunkAPI) => {
    try {
      let { data } = await axiosProtected.get(
        `/store/notifications?page=${notification.page || 0}&size=${50}&text=${notification.text || ""}&filter=${notification.filter || ""}`
      );
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      thunkAPI.rejectWithValue(e.response.data);
    }
  }
);

export const updateNotifications = createAsyncThunk(
  "store/notifications/read",
  async (notifications, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.post(
        "/store/notifications/read",
        notifications
      );
      dispatch(getNotifications({ page: 0, size: 50 }));
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);

export const updateAllNotifications = createAsyncThunk(
  "store/notifications/read-all",
  async (_notifications, { dispatch, rejectWithValue }) => {
    try {
      let { data } = await axiosProtected.post(
        "/store/notifications/read-all");
      dispatch(getNotifications({ page: 0, size: 50 }));
      return data;
    } catch (e) {
      toast.error(e.response.data.message);
      rejectWithValue(e.response.data);
    }
  }
);
